"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var financeQuotePricesStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var palette = _a.palette, typography = _a.typography, breakpoints = _a.breakpoints;
    return ({
        divider: {
            margin: '0 5px',
            fontFamily: typography.fontFamily2,
        },
        financeQuoteMultiWrapper: (_b = {
                margin: "0 5px",
                color: palette.primary.main
            },
            _b[breakpoints.down('xs')] = {
                fontSize: typography.fontSM,
            },
            _b),
        prices: {
            margin: "0 5px",
        },
        priceElement: {
            color: palette.primary.main,
            fontFamily: typography.fontFamily2,
        },
    });
}, { name: 'Summary_FinanceQuotePricesMulti' });
exports.default = financeQuotePricesStyles;
